export default __webpack_public_path__ + "fonts/option-img1.svg";